module.exports = __webpack_public_path__ + "static/media/about-part-5.bda3b799.jpg";